import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { NewLogEntryPage } from 'pages/logbook/NewLogEntryPage'

export const Route = createFileRoute('/logbook/entry/new')({
  component: RouteComponent,
  staticData: {
    title: 'New Log Entry',
  },
})

function RouteComponent() {
  const navigate = useNavigate()

  return (
    <NewLogEntryPage
      onCreate={(templateId) =>
        navigate({
          to: '/logbook/entry/$logEntryId',
          params: { logEntryId: 'draft' },
          search: { logTemplateId: templateId },
        })
      }
      onCancel={() => navigate({ to: '/logbook', search: {} })}
    />
  )
}
